/**
 * EventHubTabs — the two top-level Event Hub views.
 *
 * Deliberately NOT in EventHubLayout: these tabs belong to the landing surface
 * only. Sub-pages (event detail, edit, nomination list, create nomination) do not
 * show them — the Figma still draws the tab strip on several of those screens, but
 * that is a known artefact of screens that have not been updated yet.
 *
 * Rendered by both tab targets so either one can switch back to the other; a strip
 * that only existed on the first tab would be a one-way door.
 *
 * Routing, not local state: each tab is a real route, so a tab is linkable and the
 * Lifecycle Data half can be built by its owners without touching the home page.
 */

import { NavLink } from 'react-router-dom';
import './EventHubTabs.css';

const TABS = [
  { to: '/event', label: 'Event & Nomination' },
  { to: '/event/lifecycle-data', label: 'Event Lifecycle Data' },
];

export default function EventHubTabs() {
  return (
    <nav className="event-hub-tabs">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end
          className={({ isActive }) =>
            `event-hub-tabs__tab${isActive ? ' event-hub-tabs__tab--active' : ''}`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
